(function () {
    'use strict';

    var module = angular.module('uwAgenda.downloads');

    // controller for agenda downloads
    module.controller('DownloadAgendaController',
      ['$scope', 'SharedAgendaService', 'DateService', 'ReportType', 'DownloadService', 'ExportFormat', 'HelperService', DownloadAgendaControllerFn]);

    function DownloadAgendaControllerFn($scope, SharedAgendaService, DateService, ReportType, DownloadService, ExportFormat, HelperService) {

        var vm = this;
        // date filter
        vm.dateFrom = null;
        vm.dateTo = null;
        // report type filter
        vm.selectedReportType = null;
        vm.reportTypes = [];
        vm.pdfExportDisabled = false;

        activate();

        // change selected report type
        vm.selectReportType = function (type) {
            vm.selectedReportType = type;
            vm.pdfExportDisabled = type === ReportType.User || type === ReportType.Email;
        };

        // export as pdf
        vm.exportPdf = function () {
            generateReport(ExportFormat.PDF.value);
        };

        // export as csv
        vm.exportCsv = function () {
            generateReport(ExportFormat.CSV.value);
        };

        // activation work
        function activate() {
            // allow shared agenda-switch
            SharedAgendaService.allow();

            // add report types that are available in this view
            vm.reportTypes.push(ReportType.Agenda);
            vm.reportTypes.push(ReportType.Appointment);
            vm.reportTypes.push(ReportType.Task);
            vm.reportTypes.push(ReportType.CallMessage);
            vm.reportTypes.push(ReportType.User);
            vm.reportTypes.push(ReportType.Email);

            vm.selectedReportType = ReportType.Agenda;

            if (DateService.data.info.firstDayOfWeek) {
                vm.dateFrom = DateService.data.info.firstDayOfWeek;
                vm.dateTo = DateService.data.info.lastDayOfWeek;
            } else {
                vm.dateFrom = new Date();
                vm.dateTo = new Date();
            }

        } // activate

        // generates the report for the selected report type as pdf or csv
        function generateReport(format) {
            // block ui
            HelperService.block("#downloads");

            var userId = SharedAgendaService.currentUser().id;

            switch (vm.selectedReportType) {
                case ReportType.Agenda:
                    DownloadService.exportAgenda(format, userId, vm.dateFrom, vm.dateTo).then(function (response) { showReport(response, "agenda", format); });
                    break;
                case ReportType.Appointment:
                    DownloadService.exportAppointments(format, userId, vm.dateFrom, vm.dateTo).then(function (response) { showReport(response, "appointments", format); });
                    break;
                case ReportType.Task:
                    DownloadService.exportTasks(format, userId, vm.dateFrom, vm.dateTo).then(function (response) { showReport(response, "tasks", format); });
                    break;
                case ReportType.CallMessage:
                    DownloadService.exportCallsAndMessages(format, userId, vm.dateFrom, vm.dateTo).then(function (response) { showReport(response, "calls_messages", format); });
                    break;
                case ReportType.User:
                    DownloadService.exportContacts(userId).then(function (response) { showReport(response, "user", format); });
                    break;
                case ReportType.Email:
                    DownloadService.exportEmails(userId).then(function (response) { showReport(response, "emails", format); });
                    break;
            }
        }

        // show/download the report file
        function showReport(responseData, filenamePrefix, exportFormat) {
            // unblock ui
            HelperService.unblock("#downloads");
            DownloadService.openReport(exportFormat, responseData, filenamePrefix);
        } // showReport
    }
})();